import { getAuth, onIdTokenChanged } from "firebase/auth";
import { useUserAuthStore } from "src/store/userAuth/userAuthStore";

export function setupTokenListener() {
  const auth = getAuth();

  onIdTokenChanged(auth, async (user) => {
    if (!user) {
      useUserAuthStore.getState().setAccessToken("");
      return;
    }

    // Firebase auto-refreshed the token → update state
    const token = await user.getIdToken();
    useUserAuthStore.getState().setAccessToken(token);
  });
}